import { LoadingButton } from '@mui/lab';

// interface ContainedButtonProps extends ButtonProps {
//   handleClick?: () => void;
// }

const ContainedButton
  // : React.FC<ContainedButtonProps> 
  = ({ children, handleClick = () => { }, sx, ...props }) => {
    // console.log(props);
    return (
      <LoadingButton
        sx={{
          bgcolor: `${props.disabled ? '#FAFAFA' : props.loading ? '#fafafa' : 'primary.main'}`,
          color: 'white',
          borderWidth: '0.05px',
          borderStyle: 'solid',
          borderColor: 'transparent',
          ':hover': {
            color: 'primary.main',
            borderColor: 'primary.main',
          },

          ...sx // spread the sx prop last so it doesn't overwrite the styles we've defined
        }}
        onClick={handleClick}
        {...props}
      >
        {children}
      </LoadingButton>
    );
  };

export default ContainedButton;
